import { getAndroidInfo, PerformanceClass } from '@/shared/helpers/get-android-info';

import { PERFORMANCE_CLASS_STORED_KEY } from '../constants';

const getStoredPerformanceClass = (): PerformanceClass | null => {
  const value = localStorage.getItem(PERFORMANCE_CLASS_STORED_KEY);

  if (!value) return null;

  return Object.values(PerformanceClass).includes(value)
    ? (value as PerformanceClass)
    : null;
};

export const getIsSlowDevice = () => {
  const performanceClass = getAndroidInfo()?.performanceClass;

  const storedPerformanceClass = getStoredPerformanceClass();

  const performance = storedPerformanceClass ?? performanceClass;

  if (!performance) return false;

  return [PerformanceClass.AVERAGE, PerformanceClass.LOW].includes(performance);
};
